import * as mutations from '../../mutation-types'

export const processReminder = (store, item) => {
    if (item.reference) {
        if(item.reference.project) {
            store.dispatch('processProject', item.reference.project)
            item.project_id = item.reference.project_id
        }
        switch (item.reference_type) {
            case 'email':
                item.message = item.reference
                break;
            case 'task':
                store.dispatch('processTask', item.reference)
                break;
            case 'work-type':
                store.dispatch('processWorkType', item.reference)
                break;
            case 'service':
                store.dispatch('processService', item.reference)
                break;
            case 'project-service':
                store.dispatch('processProjectService', item.reference)
                break;
            case 'project':
                store.dispatch('processProject', item.reference)
                item.project_id = item.reference.id;
                break;
            case 'proposal':
                store.dispatch('processProposal', item.reference)
                break;
            case 'change-order':
                store.dispatch('processChangeOrder', item.reference)
        }
        
        delete item.reference
    }

    if (item.user) {
        store.dispatch('processUser', item.user)
        delete item.user
    }

    store.commit(mutations.ADD_OR_UPDATE_REMINDER, item)
}

export const fetchReminders = (store, params = {}) => {
    return axios.get(`/api/reminders`, {params})
        .then(res => {
            _.each(res.data.data, item => processReminder(store, item))
            return res
        })
}

export const createReminder = (store, item) => {
    return axios.post('/api/reminders', item)
        .then(res => {
            processReminder(store, res.data.data)
            return res
        })
}

export const updateReminder = (store, item) => {
    return axios.patch(`/api/reminders/${item.id}`, item)
        .then(res => {
            processReminder(store, res.data.data)
            return res
        })
}
export const createOrUpdateReminder = (store, item) => {
    return item.id ?
        updateReminder(store, item) :
        createReminder(store, item)
}

export const removeReminder = (store, item) => {
    return axios.delete(`/api/reminders/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_REMINDER, item)
            return res
        })
}

export const remind = (store, params) => {
    return axios.post(`/api/expirations/${params.contact_id}/remind`, params)
}
